import React from 'react';
import { MotionCard } from '../ui/MotionPrimitives';

const AboutGlobalFootprint: React.FC = () => {
  return (
    <section className="w-full bg-white py-16">
      <div className="mx-auto max-w-6xl px-6 md:px-10">
        <div className="mb-8 flex flex-col gap-3 md:flex-row md:items-baseline md:justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-black">
              II. Global Presence
            </p>
            <h2 className="mt-2 text-3xl font-semibold tracking-tight text-black md:text-4xl">
              Strategic Global Footprint
            </h2>
          </div>
        </div>

        <p className="max-w-3xl text-sm leading-relaxed text-black md:text-base">
          Hogar Dorado House&apos;s competitive advantage lies in its dual-market specialization. By
          actively managing investments in both the mature, stable US market and the high-yield,
          rapidly expanding UAE market, we provide diversified, de-risked opportunities for wealth
          creation.
        </p>

        <div className="mt-10 grid gap-8 md:grid-cols-2">
          <MotionCard className="rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
            <h3 className="text-lg font-semibold text-black">
              UAE Focus
              <span className="block text-xs font-medium uppercase tracking-wide text-[rgb(216,133,70)]">
                Dubai, Jumeirah Lake Towers – HQ
              </span>
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-black">
              Concentration on ultra-modern commercial and high-end residential assets, capitalizing
              on the region&apos;s strong economic fundamentals and continuous population growth.
            </p>
          </MotionCard>

          <MotionCard className="rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
            <h3 className="text-lg font-semibold text-black">USA Focus</h3>
            <p className="mt-3 text-sm leading-relaxed text-black">
              Targeting established and emerging metropolitan areas for both residential and
              commercial real estate, optimizing for rental yield and long-term capital
              appreciation.
            </p>
          </MotionCard>
        </div>
      </div>
    </section>
  );
};

export default AboutGlobalFootprint;
